/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { useState } from 'react'

type State = 'idle' | 'sending' | 'done' | 'error'

export function WaitlistForm() {
  const [email, setEmail] = useState('')
  const [state, setState] = useState<State>('idle')
  const [message, setMessage] = useState('')

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (state === 'sending') return
    setState('sending')
    setMessage('')
    try {
      const res = await fetch('/api/waitlist', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (!res.ok) {
        setState('error')
        setMessage(data.message ?? 'That didn’t work. Try again?')
        return
      }
      setState('done')
      setMessage(
        data.alreadyOn ? 'You were already on the list. Still are.' : 'You’re on the list.',
      )
    } catch {
      setState('error')
      setMessage('Network trouble — try again in a moment.')
    }
  }

  if (state === 'done') {
    return (
      <p className='rounded-xl bg-black/10 px-4 py-3 font-medium' role='status'>
        ✓ {message} We’ll write once, when it’s real.
      </p>
    )
  }

  return (
    <form onSubmit={submit} className='flex flex-col gap-2 sm:flex-row'>
      <label htmlFor='waitlist-email' className='sr-only'>
        Email address
      </label>
      <input
        id='waitlist-email'
        type='email'
        required
        value={email}
        onChange={(e) => setEmail(e.currentTarget.value)}
        placeholder='you@example.com'
        autoComplete='email'
        aria-invalid={state === 'error'}
        aria-describedby={state === 'error' ? 'waitlist-error' : undefined}
        className='min-w-0 flex-1 rounded-full border border-black/15 bg-white/90 px-4 py-3 text-[var(--color-bark-900)] placeholder:text-[var(--color-bark-400)] focus:outline-none'
      />
      <button
        type='submit'
        disabled={state === 'sending'}
        className='rounded-full bg-[var(--color-bark-950)] px-6 py-3 font-semibold text-white disabled:opacity-60'
      >
        {state === 'sending' ? 'Adding…' : 'Join'}
      </button>
      {state === 'error' && (
        <p id='waitlist-error' role='alert' className='text-sm font-medium sm:absolute sm:mt-14'>
          {message}
        </p>
      )}
    </form>
  )
}
